// Day 10 — priced reminder.

import type { EmailData } from "../../types";
import { longDate } from "../../format";
import { b, esc, p } from "../../layouts/chrome";
import { NO_PAYMENT, pricedEmailHtml } from "../../layouts/priced";
import { brand } from "../brand";

export const subject = (_data: EmailData) => `Your ${brand.name} policy will not auto-renew`;

export const html = (data: EmailData) =>
  pricedEmailHtml({
    brand,
    data,
    callNumber: brand.callNumber,
    quotes: data.quotes ?? [],
    payment: data.payment ?? NO_PAYMENT,
    policyRef: data.policyRef,
    versionRef: data.versionRef,
    bodyHtml: p(
      `This is a reminder from ${brand.name} that your insurance policy for ${b(`'${esc(data.companyName)}' is due for renewal on ${longDate(data.renewalDate)}`)}. Your policy ${b("will not auto-renew")} — renewing now avoids any last-minute rush and any gap in your cover.`,
    ),
  });
